export default "__VITE_ASSET__CoDOwxyn__"